










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

// Register only the components we need (tree-shaking friendly)
Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend);

@Component({})
export default class BarChartComponent extends Vue {
  @Prop({ required: true }) labels!: string[];
  @Prop({ required: true }) values!: number[];
  @Prop({ default: 'Anzahl' }) datasetLabel!: string;
  @Prop({ default: '#1976D2' }) color!: string;
  @Prop({ default: false }) compact!: boolean;
  @Prop({ default: false }) horizontal!: boolean;
  @Prop({ default: 130 }) height!: number;
  @Prop({ default: undefined }) aspectRatio!: number | undefined;

  private chart: Chart | null = null;

  mounted() {
    this.renderChart();
  }

  beforeDestroy() {
    this.chart?.destroy();
  }

  @Watch('labels')
  @Watch('values')
  @Watch('horizontal')
  @Watch('height')
  @Watch('aspectRatio')
  onDataChange() {
    this.chart?.destroy();
    this.renderChart();
  }

  private renderChart() {
    const canvas = this.$refs.canvas as HTMLCanvasElement;
    if (!canvas) return;

    this.chart = new Chart(canvas, {
      type: 'bar',
      data: {
        labels: this.labels,
        datasets: [{
          label: this.datasetLabel,
          data: this.values,
          backgroundColor: this.color,
          borderRadius: 3,
          maxBarThickness: 24,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: !this.compact,
        ...(this.aspectRatio !== undefined ? { aspectRatio: this.aspectRatio } : {}),
        indexAxis: this.horizontal ? 'y' : 'x',
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: (items) => items[0].label,
              label: (item) => ` ${item.formattedValue}`,
            },
          },
        },
        scales: this.horizontal
          ? {
              x: {
                beginAtZero: true,
                ticks: { font: { size: 10 } },
              },
              y: {
                ticks: {
                  font: { size: 10 },
                  callback(value, index) {
                    const label = String(this.getLabelForValue(index));
                    return label.length > 24 ? label.slice(0, 24) + '…' : label;
                  },
                },
                grid: { display: false },
              },
            }
          : {
              x: {
                ticks: {
                  maxRotation: 60,
                  font: { size: 10 },
                  callback(value, index) {
                    const label = String(this.getLabelForValue(index));
                    return label.length > 12 ? label.slice(0, 12) + '…' : label;
                  },
                },
                grid: { display: false },
              },
              y: {
                beginAtZero: true,
                ticks: { font: { size: 10 } },
              },
            },
      },
    });
  }
}
